export const LOADING_OPPORTUNITIES = "LOADING_OPPORTUNITIES";
export const GET_OPPORTUNITIES_LIST = "GET_OPPORTUNITIES_LIST";
export const REMOVE_OPPORTUNITIES = "REMOVE_OPPORTUNITIES";
export const ADD_OPPORTUNITIES = "ADD_OPPORTUNITIES";
export const UPDATE_OPPORTUNITIES = "UPDATE_OPPORTUNITIES";
export const GET_OPPORTUNITY_ID = "GET_OPPORTUNITY_ID";
export const UPDATE_OPPORTUNITY_STATUS = "UPDATE_OPPORTUNITY_STATUS";
export const GET_PIPELINES_LIST = "GET_PIPELINES_LIST";

